import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/ui/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center space-y-6 max-w-md">
        <div className="space-y-2">
          <h1 className="text-6xl font-bold text-primary">404</h1>
          <h2 className="text-2xl font-semibold text-foreground">
            Página não encontrada
          </h2>
          <p className="text-muted-foreground">
            A página que você está procurando não existe ou foi movida.
          </p>
        </div>

        <div className="space-y-3">
          <Button variant="premium" size="lg" asChild>
            <a href="/">Voltar ao Início</a>
          </Button>

          <Button variant="ghost" asChild>
            <a href="/login">Fazer Login</a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
